module.exports = __webpack_public_path__ + "static/media/searching.97514f2c.gif";